import React from 'react';
import PropTypes from 'prop-types';
import Assembly from '../assemblies/component';
import { consistentString } from '../../utils/content-formatting';
import { RichTextPropTypes } from '../../prop-types';
import RichText from '../rich-text';

// Styles
import {
  Wrapper,
  FlexBetweenContainer,
  ContentHalfWidth,
  HeaderText,
  TextWrapper,
  StyledContainer,
} from './styles';
import { useLayout } from '../layout/context';

export const safeBackgroundRTE = (bg) =>
  ['white', 'grey'].includes(bg) ? bg : null;

const TwoColumnGenericBlock = ({
  headerText,
  leftColumnBodyCopy,
  rightColumnBodyCopy,
  leftColumnAssemblies,
  rightColumnAssemblies,
  backgroundColor,
  removeMarginBottom,
}) => {
  const { insideContainer, insideHalfWidth, insideSideBar } = useLayout();

  return (
    <Wrapper
      $backgroundColor={backgroundColor}
      $padding={!insideContainer}
      $removeMarginBottom={removeMarginBottom}
    >
      <StyledContainer
        $padding={!insideContainer || backgroundColor === 'grey'}
      >
        {headerText ? (
          <HeaderText $backgroundColor={backgroundColor}>
            {headerText}
          </HeaderText>
        ) : null}

        <FlexBetweenContainer>
          <ContentHalfWidth
            $insideNarrowLayout={!!(insideHalfWidth || insideSideBar)}
            $backgroundColor={backgroundColor}
          >
            {leftColumnBodyCopy && (
              <TextWrapper>
                <RichText richText={leftColumnBodyCopy} />
              </TextWrapper>
            )}
            {leftColumnAssemblies &&
              leftColumnAssemblies.map((assembly, i) => (
                <Assembly
                  assembly={assembly}
                  key={`lca-${assembly.internal.type}-${i}`}
                />
              ))}
          </ContentHalfWidth>
          <ContentHalfWidth
            $insideNarrowLayout={!!(insideHalfWidth || insideSideBar)}
            $backgroundColor={backgroundColor}
          >
            {rightColumnBodyCopy && (
              <TextWrapper>
                <RichText richText={rightColumnBodyCopy} />
              </TextWrapper>
            )}
            {rightColumnAssemblies &&
              rightColumnAssemblies.map((assembly, i) => (
                <Assembly
                  assembly={assembly}
                  key={`rca-${assembly.internal.type}-${i}`}
                />
              ))}
          </ContentHalfWidth>
        </FlexBetweenContainer>
      </StyledContainer>
    </Wrapper>
  );
};

TwoColumnGenericBlock.propTypes = {
  headerText: PropTypes.string,
  leftColumnBodyCopy: RichTextPropTypes,
  rightColumnBodyCopy: RichTextPropTypes,
  leftColumnAssemblies: PropTypes.array,
  rightColumnAssemblies: PropTypes.array,
  backgroundColor: PropTypes.oneOf(['white', 'black', 'grey']),
  removeMarginBottom: PropTypes.bool,
};

TwoColumnGenericBlock.defaultProps = {
  backgroundColor: 'white',
};

export default TwoColumnGenericBlock;

export const TwoColumnGenericBlockAssembly = ({ contentfulData }) => (
  <TwoColumnGenericBlock
    headerText={contentfulData.headerText}
    leftColumnBodyCopy={contentfulData.leftColumnBodyCopy}
    rightColumnBodyCopy={contentfulData.rightColumnBodyCopy}
    leftColumnAssemblies={contentfulData.leftColumnAssemblies}
    rightColumnAssemblies={contentfulData.rightColumnAssemblies}
    backgroundColor={consistentString(
      contentfulData.backgroundColor || 'white'
    )}
    removeMarginBottom={contentfulData.removeMarginBottom}
  />
);

TwoColumnGenericBlockAssembly.propTypes = {
  contentfulData: PropTypes.object,
};
